<template>
    <div>
      <div class="supplement-step4-content">
        <span :class="[isError ? 'el-icon-warning' : 'el-icon-success']"></span>
        <span>{{isError ? $t('message.user.passError') : $t('message.user.authentication')}}</span>
        <span class="content-desc">{{tips}}</span>
      </div>
      <div class="margin-top-20">
      <el-button
        :loading="dataLoading"
        style="width: 100%"
        type="primary"
        @click="onSubmit"
        >{{ isError ? $t('message.user.updateRegisterInfo') : $t("message.user.logout") }}</el-button>
      </div>
    </div>
</template>

<script>
import { doLogout } from '@/api/common/user';
import { removeLocalStorage } from '@/utils/tools/utils';

export default {
  props: {
    tips: {
      type: String,
      default: '',
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataLoading: false,
    };
  },
  methods: {
    async onSubmit() {
      if (this.isError) { // 审核不通过，则返回
        this.$emit('edit');
        return;
      }
      this.dataLoading = true;
      try {
        await doLogout();
        removeLocalStorage('userLogin');
        window.location.href = '/user/login';
      } catch (err) {
      }
      this.dataLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/element-variables.scss';
.supplement-step4-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 180px;
  margin-bottom: 90px;
  font-size: 16px;
  font-weight: 600;
  color: $color-text-primary;
  line-height: 22px;

  .content-desc {
    font-size: 14px;
    font-weight: normal;
    margin-top: 14px;
  }

  .el-icon-success {
    color: #00A2DD;
    font-size: 108px;
    line-height: 1;
    font-weight: normal;
    margin-bottom: 18px;
  }

  .el-icon-warning {
    color: $color-danger;
    font-size: 108px;
    line-height: 1;
    font-weight: normal;
    margin-bottom: 18px;
  }
}
</style>
